namespace GeniuzPOS.Purchase {
    export namespace PoPo05DtPendingPIforIrService {
        export const baseUrl = 'Purchase/PoPo05DtPendingPIforIr';

        export declare function Create(request: Serenity.SaveRequest<PoPo05DtPendingPIforIrRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PoPo05DtPendingPIforIrRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PoPo05DtPendingPIforIrRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PoPo05DtPendingPIforIrRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PoPo05DtPendingPIforIr/Create",
            Update = "Purchase/PoPo05DtPendingPIforIr/Update",
            Delete = "Purchase/PoPo05DtPendingPIforIr/Delete",
            Retrieve = "Purchase/PoPo05DtPendingPIforIr/Retrieve",
            List = "Purchase/PoPo05DtPendingPIforIr/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PoPo05DtPendingPIforIrService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
